import React, { FC, useEffect, useRef, useState } from 'react';
import { useTableUniverse } from '~Components/TableUniverse';
import { useChequeContext } from '~Scenes/Handy/Context/ChequeContext';
import { usePage } from '~Scenes/Handy/Context/PageProvider';
import { useTableContext } from '~Scenes/Handy/Context/TableContext';
import HistoryOrder from '~Scenes/History-v2/Components/HistoryOrder';
import { useLogger } from '~Hooks';
import { TablesAndFloorPlansQuery_venue_floorPlans_tables } from '~Scenes/Handy/__queries__';

const Order: FC = () => {
  const page = usePage();
  const { setSelectedTable } = useTableContext();
  const { setSelectedCheque } = useChequeContext();
  const universe = useTableUniverse();
  const logger = useLogger('handy-history-order');

  // Store the chequeId we're waiting for from the copy-to-table flow.
  // When universe.cheques updates with this cheque, we navigate to ordering.
  const pendingChequeId = useRef<string | null>(null);
  const pendingTable = useRef<TablesAndFloorPlansQuery_venue_floorPlans_tables | null>(null);

  useEffect(() => {
    if (!pendingChequeId.current) return;

    const cheque = universe.cheques.find((c) => c.id === pendingChequeId.current);
    if (cheque) {
      logger.info('Found pending cheque in universe, navigating to ordering', {
        chequeId: pendingChequeId.current,
      });
      pendingChequeId.current = null;
      setSelectedCheque(cheque);
      setSelectedTable(pendingTable.current);
      page.setPageHistory(page.pageHistory.slice(0, 1)); // Makes the back button lead to home instead of history
      page.navigateTo('ordering');
    }
  }, [universe.cheques]);

  if (!page.slug) {
    return null;
  }

  return (
    <>
      <HistoryOrder
        orderId={page.slug}
        onHandyCopyOrderComplete={(table, chequeId) => {
          logger.info('Copy order complete, waiting for cheque in universe', {
            chequeId,
            tableId: table.id,
          });
          pendingChequeId.current = chequeId;
          pendingTable.current = table;
        }}
      />
    </>
  );
};

export default Order;
